(() => {
  'use-strict';

  function initChoiceHelperForm(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('initChoiceHelperForm' in element.dataset) {
        return;
      }
      element.dataset.initChoiceHelperForm = true;

      const allCheckboxes = element.querySelectorAll('input[type="checkbox"][value="all"]');

      allCheckboxes.forEach((checkboxAll) => {
        const siblingCheckboxes = checkboxAll.closest('.form-checkboxes').querySelectorAll('input:not([value="all"])');

        checkboxAll.addEventListener('change', () => {
          siblingCheckboxes.forEach((sibling) => {
            sibling.checked = false;
          });
        });

        siblingCheckboxes.forEach((sibling) => {
          sibling.addEventListener('change', () => {
            checkboxAll.checked = false;
          });
        });
      });
    });
  }

  Drupal.behaviors.choiceHelperForm = {
    attach: () => {
      const choiceHelperForm = document.querySelectorAll('.choice-helper-form');
      if (choiceHelperForm.length !== 0) {
        initChoiceHelperForm(choiceHelperForm);
      }
    },
  };
})();
